export function getDeliveryRooms(roomId) {
    return abp.ajax({
        url: '/api/services/app/DeliveryRecord/GetDeliveryRooms',
        method: 'get',
        params: {}
    });
}

/*提交预约*/
export function submitAppointment(data) {
    return abp.ajax({
        url: '/api/services/app/DeliveryRecord/SubmitAppointment',
        method: 'post',
        data: data
    });
}

/*提交资料*/
export function submitData(data) {
    return abp.ajax({
        url: '/api/services/app/DeliveryRecord/SubmitData',
        method: 'post',
        data: data
    });
}

export function createOtherOwners(data) {
    return abp.ajax({
        url: '/api/services/app/DeliveryRecord/CreateOtherOwners',
        method: 'post',
        data: data
    });
}
